import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatCardModule } from '@angular/material/card'
import { MatDialogModule } from '@angular/material/dialog'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatPaginatorModule } from '@angular/material/paginator'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatSortModule } from '@angular/material/sort'
import { MatTableModule } from '@angular/material/table'
import { BrowserModule } from '@angular/platform-browser'
import { RouterModule } from '@angular/router'
import { TablerIconsModule } from 'angular-tabler-icons'
import { IconSearch } from 'angular-tabler-icons/icons'
import { ProveedoresRoutingModule } from './proveedores-routing.module'
import { ProveedoresComponent } from './proveedores.component'
import { DialogProveedoresComponent } from './ver-proveedores/dialog-proveedores/dialog-proveedores.component'
import { VerProveedoresComponent } from './ver-proveedores/ver-proveedores.component'

@NgModule({
  declarations: [
    ProveedoresComponent,
    VerProveedoresComponent,
    DialogProveedoresComponent
  ],
  imports: [
    FormsModule,
    RouterModule,
    CommonModule,
    MatIconModule,
    MatSortModule,
    MatCardModule,
    BrowserModule,
    MatTableModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    MatPaginatorModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    ProveedoresRoutingModule,
    TablerIconsModule.pick({
      IconSearch
    })
  ]
})
export class ProveedoresModule {}
